/* React */
import React from "react";

/* Ionic */
import { IonContent } from "@ionic/react";

/* Stylesheet */
import styles from "./AdminDashboardWrapper.module.scss";

/* Interfaces */
interface AdminDashboardWrapperProps {
  children: React.ReactNode;
}

const AdminDashboardWrapper: React.FC<
  AdminDashboardWrapperProps
> = ({ children }) => {
  return (
    <div className={styles.admin_dashboard_wrapper}>
      <IonContent className={styles.content_container}>
        <div className={styles.children_container}>
          {children}
        </div>
      </IonContent>
    </div>
  );
};

export default AdminDashboardWrapper;
